// extracted by mini-css-extract-plugin
module.exports = {"reportWrapper":"style__reportWrapper__p+npQ"};